module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"start_help_video","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"ls":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"level":{"type":"string"},"style":{"type":"string"}},"required":["user","ls","level"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/start_help_video.json
// module id = 576
// module chunks = 100